<template>
  <div>
    <modal-template
      v-show="toggle"
      @close="toggleInfoModal"
      class="override-modal"
    >
      <template #header>
        <i class="icon-ic_close" @click="toggleInfoModal" />
        <h3>{{ $t('labels.observacao') }}</h3>
      </template>
      <template #body>
        <div class="exam-preparation">
          <h2 class="exam-subtitle">
            {{ $t('labels.recomendacoes') }}
          </h2>
          <ul class="exam-item">
            <li
              v-for="informacao in dadosExames.Recomendacoes.InformacoesGerais"
              :key="informacao"
            >
              {{ informacao }}
            </li>
          </ul>
          <h2 class="exam-subtitle">
            {{ $t('labels.atendimentos') }}
          </h2>
          <ul class="exam-item">
            <li
              v-for="exame in dadosExames.Recomendacoes.Exames"
              :key="exame.index"
            >
              {{ exame.Descricao }}
            </li>
          </ul>
        </div>
      </template>
      <template #footer>
        <b-button class="close-modal" @click="toggleInfoModal">
          {{ $t('botoes.entendi') }}
        </b-button>
      </template>
    </modal-template>
  </div>
</template>

<script>
import ModalTemplate from '../modal/ModalTemplate'
export default {
  name: 'PreparationModal',
  components: { ModalTemplate },
  props: {
    toggle: {
      type: Boolean,
      required: true
    },
    dadosExames: {
      type: Object,
      default: null
    }
  },
  methods: {
    toggleInfoModal() {
      this.$emit('closeModal')
    }
  }
}
</script>

<style lang="scss" scoped src="@/assets/stylesheets/components/shared/modal/PreparationModal.scss"></style>
